<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
              <div class="card-icon clickable" @click="close()">
                <md-icon>arrow_back</md-icon>
              </div>
              <h4 class="title">Thông tin chi tiết</h4>
            </md-card-header>
            <md-card-content class="md-layout border-content">
              <div v-if="isAddNew" class="md-layout-item md-size-25">
                <md-field>
                  <label>Mã sản phẩm</label>
                  <md-input required v-model="form.productId"></md-input>
                </md-field>
              </div>
              <div v-else class="md-layout-item md-size-25">
                <md-field>
                  <label>Mã sản phẩm</label>
                  <md-input
                    disabled
                    required
                    v-model="form.productId"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-25">
                <md-field>
                  <label>Tên sản phẩm</label>
                  <md-input
                    @change="changes = true"
                    required
                    v-model="form.name"
                    :disabled="!isAddNew"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-25">
                <md-autocomplete
                  @change="changes = true"
                  v-model="form.type[0]"
                  :md-options="suggestion.type"
                  :md-open-on-focus="true"
                >
                  <label>Loại sản phẩm:</label>
                </md-autocomplete>
              </div>
              <div class="md-layout-item md-size-25">
                <md-field>
                  <label>Số lượng</label>
                  <md-input
                    @change="changes = true"
                    v-model="form.warehouse"
                    type="number"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-25">
                <md-field>
                  <label>Nhà sản xuất</label>
                  <md-input
                    @change="changes = true"
                    v-model="form.manufacturer"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-25">
                <md-field>
                  <label>Năm chế tạo</label>
                  <md-input
                    @change="changes = true"
                    v-model="form.harvestTime"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-25">
                <md-field>
                  <label>Giá bán</label>
                  <md-input
                    @change="changes = true"
                    required
                    v-model="form.price"
                    type="number"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-25">
                <md-field>
                  <label>Đơn vị tính</label>
                  <md-input
                    @change="changes = true"
                    required
                    v-model="form.unit"
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-25">
                <md-field>
                  <label>Mô tả</label>
                  <md-textarea
                    @change="changes = true"
                    v-model="form.additionalInfo"
                    :md-autogrow="true"
                  ></md-textarea>
                </md-field>
              </div>
              <div class="md-layout-item md-size-25">
                <md-field>
                  <label>Hướng dẫn sử dụng</label>
                  <md-textarea
                    @change="changes = true"
                    v-model="form.userManual"
                    :md-autogrow="true"
                  ></md-textarea>
                </md-field>
              </div>
              <div class="md-layout-item md-size-60 border-box">
                <md-button
                  class="md-sm md-success"
                  @click="referToInputPickFile()"
                  >Thêm ảnh</md-button
                >
                <div class="box-image">
                  <div
                    :key="index"
                    v-for="(items, index) in form.pictureUrl"
                    class="md-xsmall-size-33"
                  >
                    <i
                      class="far fa-times-circle clickable icon-remove"
                      @click="removeImg(items)"
                    >
                      <md-tooltip>Xóa ảnh</md-tooltip>
                    </i>
                    <img :src="items.url" style="max-width: 15vh" />
                  </div>
                  <div
                    class="md-layout-item md-size-33"
                    v-show="progress !== 100"
                  >
                    <center>
                      <p class="card-title">
                        {{ Math.floor(progress) + " %" }}
                      </p>
                    </center>
                    <md-progress-bar
                      class="md-primary"
                      :md-value="progress"
                    ></md-progress-bar>
                  </div>
                  <input
                    id="iconImage"
                    @change="addImg"
                    type="file"
                    accept="image/png, image/jpeg"
                    ref="inputFile"
                    style="display: none"
                  />
                </div>
              </div>
              <div
                class="md-layout-item md-size-25 md-xsmall-size-100 border-box"
                style="margin-left: 10px"
              >
                <md-field>
                  <div class="md-layout-item md-size-20">
                    <md-button
                      class="md-success button-addImg md-dense"
                      @click="referToInputPickFileThumbnail"
                    >
                      Tải ảnh đại diện
                      <md-tooltip>Tải ảnh đại diện cho sản phẩm</md-tooltip>
                    </md-button>
                  </div>
                </md-field>
                <div class="md-layout">
                  <img
                    :src="form.pictureThumbnail"
                    style="height: 100px; width: auto; margin: auto"
                    class="image"
                  />
                </div>
                <input
                  id="iconImage"
                  @change="addImgThumbnail"
                  type="file"
                  accept="image/png, image/jpeg"
                  ref="inputFileThumbnail"
                  style="display: none"
                />
              </div>
            </md-card-content>
            <md-card-actions>
              <md-button
                class="md-success"
                type="submit"
                :disabled="flagLoading"
              >
                Hoàn tất
              </md-button>
              <md-button class="md-danger" @click="close">Đóng</md-button>
            </md-card-actions>
          </md-card>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import * as firebase from "firebase";
import Compressor from "compressorjs";
import EventBus from "../../EventBus.js";
import { mapGetters } from "vuex";
export default {
  props: ["isAddNew", "itemSelected"],
  data() {
    return {
      ref: null,
      progress: 100,
      changes: false,
      storageRef: {},
      listProducts: [],
      db: {},
      form: {
        productId: "", // mã phụ kiện -String //
        name: "", // tên phụ kiện -String //
        additionalInfo: "", // mô tả -String //
        type: [], // loại phụ kiện -String //
        price: 0, // giá bán -Number (Int) //
        unit: "", // đơn vị tính -String //
        warehouse: 0, // Số lượng trong kho -Number(Int) //
        creationTime: new Date(Date.now()).valueOf(), // Ngày tạo (filter) -Number(Int)
        manufacturer: "", // Nhà sx String //
        pictureThumbnail: "", // icon base64
        pictureUrl: [], // Hình ảnh array
        userManual: "", // Hướng dẫn sử dụng //
        harvestTime: "20", // năm chế tạo String //
        tags: ["Phụ kiện"],
      },
      type: [],
      suggestion: {
        type: [],
      },
    };
  },
  async created() {
    this.db = firebase.firestore();
    if (this.isAddNew === false) {
      this.form = this.itemSelected.data;
      this.type = this.itemSelected.data.type;
      this.storageRef = firebase
        .storage()
        .ref("Products")
        .child(this.itemSelected.id);
    } else {
      let bits = localStorage.getItem("bits");
      this.ref = this.db.collection(process.env.VUE_APP_WINE + bits).doc();
      this.storageRef = firebase.storage().ref("Products").child(this.ref.id);
    }
    await this.db
      .collection(process.env.VUE_APP_SUGGESTION_LIST)
      .doc("accessories")
      .get()
      .then((doc) => {
        if (doc.exists) {
          this.suggestion = doc.data();
        }
      });
    let bits = localStorage.getItem("bits");
    await this.db
      .collection("--stats--")
      .doc(process.env.VUE_APP_LIST_WINE + bits)
      .get()
      .then((docRef) => {
        if (docRef.exists) {
          docRef.data().listWine.forEach((item) => {
            this.listProducts.push(item.productId);
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.$store.dispatch("FLAG_LOADING", false);
      });
  },
  computed: {
    ...mapGetters(["flagLoading"]),
  },
  methods: {
    referToInputPickFile() {
      this.$refs.inputFile.click();
    },
    addImg(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return false;
      } else if (
        files[0].type !== "image/jpeg" &&
        files[0].type !== "image/png" &&
        files[0].type !== "image/jpg"
      ) {
        this.$notify({
          timeout: 3000,
          type: "warning",
          message: "Chỉ cho phép ảnh định dạng jpeg, png hoặc jpg! Thử lại!",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
      } else {
        this.uploadImg(files[0]);
      }
    },
    async uploadImg(file) {
      var fileReader = new FileReader();
      var _this = this;
      fileReader.onload = function (event) {
        var imagesRef = _this.storageRef.child(
          new Date(Date.now()).valueOf().toString()
        );
        imagesRef.put(file).on(
          "state_changed",
          (snapshot) => {
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            _this.progress = progress;
          },
          (error) => {
            console.log(error);
          },
          () => {
            _this.$messageSuccess("Tải ảnh lên thành công");
            imagesRef.getDownloadURL().then((downloadURL) => {
              _this.form.pictureUrl.push({
                ref: imagesRef.location.path,
                url: downloadURL,
              });
              let bits = localStorage.getItem("bits");
              this.db
                .collection(process.env.VUE_APP_WINE + bits)
                .doc(this.itemSelected.id)
                .update({ pictureUrl: _this.form.pictureUrl })
                .then(() => {})
                .catch((error) => {
                  console.log(error);
                });
            });
          }
        );
      };
      fileReader.readAsDataURL(file);
    },
    removeImg(item) {
      var desertRef = firebase.storage().ref(item.ref);
      desertRef
        .delete()
        .then(() => {
          this.$messageSuccess("Đã xóa ảnh khỏi cơ sở dữ liệu");
        })
        .catch((error) => {
          console.log(error);
        });
      this.form.pictureUrl.splice(this.form.pictureUrl.indexOf(item), 1);
    },
    referToInputPickFileThumbnail() {
      this.$refs.inputFileThumbnail.click();
    },
    addImgThumbnail(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return false;
      } else if (
        files[0].type !== "image/jpeg" &&
        files[0].type !== "image/png" &&
        files[0].type !== "image/jpg"
      ) {
        this.$notify({
          timeout: 3000,
          type: "warning",
          message: "Chỉ cho phép ảnh định dạng jpeg, png hoặc jpg! Thử lại!",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
      } else {
        this.upLoadThumbnail(files[0]);
      }
    },
    upLoadThumbnail(file) {
      let _this = this;
      new Compressor(file, {
        maxWidth: 250,
        quality: 0.8,
        convertSize: 30000,
        mimeType: "image/png",
        success(result) {
          var fileReader = new FileReader();
          fileReader.readAsDataURL(result);
          fileReader.onload = function (event) {
            _this.form.pictureThumbnail = event.target.result;
            let bits = localStorage.getItem("bits");
            _this.db
              .collection(process.env.VUE_APP_WINE + bits)
              .doc(_this.productSelected.id)
              .update({ pictureThumbnail: _this.form.pictureThumbnail })
              .then();
          };
        },
        error(err) {},
      });
    },
    submit() {
      this.checkValidate();
      this.$store.dispatch("FLAG_LOADING", true);
      if (this.isAddNew) {
        this.addNewAccessories();
      } else this.updateAccessories();
    },
    checkValidate() {
      if (parseInt(this.form.number) < 0) {
        alert("Số lượng không hợp lệ");
        return false;
      }
      if (parseInt(this.form.price) < 0) {
        alert("Giá bán không hợp lệ");
        return false;
      }
    },
    async addNewAccessories() {
      // this.form.type.push(this.type);
      if (this.listProducts.includes(this.form.productId)) {
        alert("Mã sản phẩm đã bị trùng");
        this.$store.dispatch("FLAG_LOADING", false);
      } else {
        try {
          await this.$store.dispatch("addAccessory", {
            ref: this.ref,
            accessory: this.form,
          });
          this.$messageSuccess("Thêm phụ kiện thành công");
          this.updateSuggesstionList();
          this.changes = false;
          this.$store.dispatch("getAccessoriesByName", this.form.name);
          this.$emit("close");
        } catch (error) {
          this.$messageError("Lỗi thêm phụ kiện");
        }
      }
    },
    async updateAccessories() {
      try {
        await this.$store.dispatch("updateAccessory", {
          id: this.itemSelected.id,
          data: this.form,
        });
        this.$messageSuccess("Cập nhật thành công");
        this.updateSuggesstionList();
        this.changes = false;
      } catch (error) {
        this.$messageError("Lỗi cập nhật phụ kiện");
      }
    },
    updateSuggesstionList() {
      let bits = localStorage.getItem("bits");
      this.suggestion.type.forEach((item) => {
        if (item === this.form.type) {
          return false;
        } else {
          this.db
            .collection(process.env.VUE_APP_SUGGESTION_LIST)
            .doc("accessories")
            .update({
              type: firebase.firestore.FieldValue.arrayUnion(this.form.type[0]),
            });
        }
      });
    },
    close() {
      if (this.changes) {
        if (
          !confirm("Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn thoát?")
        ) {
          return;
        }
      }
      this.$emit("close");
      EventBus.$emit(
        "changeListProduct",
        this.isAddNew ? "addNew" : this.itemSelected.id
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.border-box {
  border: solid rgb(175, 175, 175) 1px;
  min-height: 10vh;
  border-radius: 10px;
}
.box-image {
  border-top: solid rgb(175, 175, 175) 1px;
  display: flex;
  justify-content: flex-start;
}
</style>
